import cn from 'classnames';
import type { FC } from 'react';
import { Controller } from 'react-hook-form';
import PhoneInput from 'react-phone-input-2';
import ru from 'react-phone-input-2/lang/ru.json';
import { shopCantEditEmailAndPhoneNotify } from '@pages/personal/client/editor-page/Modals/helpers.ts';
import { useAppDispatch } from '@shared/hooks/index.ts';
import * as st from './styles.module.scss';

interface Props {
  control: any;
  name: string;
  disabled?: boolean;
  error: boolean;
  label: string | undefined;
  tabindex?: number;
  variant?: 'outline' | 'online' | 'presentation';
  onValueChange?: () => void;
  isEditable?: boolean;
}

const PhoneControlled: FC<Props> = ({
  control,
  label,
  error,
  name,
  disabled,
  variant,
  onValueChange,
  tabindex,
  isEditable = true,
}) => {
  const dispatch = useAppDispatch();
  return (
    <Controller
      name={name}
      render={({ field: { onChange, value, onBlur } }) => {
        return (
          <>
            <label
              className={cn(
                variant === 'outline' && st.label_outline,
                variant === 'online' && st.label_online,
                error && st.error
              )}
              htmlFor={name}
            >
              <p>{label}</p>
            </label>
            <div className={cn(st.controller, error && st.error)}>
              <PhoneInput
                onClick={(e) => {
                  !isEditable &&
                    dispatch(shopCantEditEmailAndPhoneNotify()) &&
                    e.currentTarget.blur();
                }}
                disabled={disabled}
                placeholder="+7 (000) 000-00-00"
                country={'ru'}
                value={value}
                onBlur={onBlur}
                onChange={(newValue) => {
                  onChange(newValue);
                  value !== newValue && onValueChange && onValueChange();
                }}
                localization={ru}
                inputClass={cn(st.input, error && st.error, variant && st[variant])}
                specialLabel=""
                containerClass={cn(st.wrapper, variant && st[variant])}
                buttonClass={cn(st.button, variant && st[variant])}
                // countryCodeEditable={false}
              />
            </div>
          </>
        );
      }}
      rules={{
        required: 'Это поле обязательно',
        minLength: { value: 7, message: 'Номер слишком короткий' },
      }}
      control={control}
    />
  );
};

export default PhoneControlled;
